import { combineReducers } from '@reduxjs/toolkit';
import fuse from './fuse';
import i18n from './i18nSlice';
import user from './userSlice';
import util from './utilSlice';
import subscriptions from './subscriptionSlice';
import channels from './channelsSlice';
import post from './postSlice';
import channelInvites from './channelInvitesSlice';
import channelApplications from './channelApplicationsSlice';
import contacts from './contactsSlice';
import chimeMeeting from './chimeMeetingSlice';
import connections from './connectionsSlice';
import groups from './groupsSlice';
import home from './homeSlice';
import notifications from './notificationsSlice';
import fileItems from './fileItemsSlice';
import helpContent from './helpContentSlice';
import clients from './clientsSlice';
import clientsAuthorized from './clientsAuthorizedSlice';
import organizations from './organizationsSlice';
import organizationReferrals from './organizationReferralsSlice';
import programs from './programsSlice';
import orgLocations from './orgLocationsSlice';
import referrals from './referralsSlice';
import referralInterest from './referralInterestSlice';
import report from './reportSlice';
import externalMessages from './externalMessageSlice';
import dmChannels from './dmChannelSlice';
import support from './supportSlice';
import subscriptionPlan from './subscriptionPlanSlice';
import videoCall from './videoCallSlice';
import marketing from './marketing';
import warning from './warningSlice';
import aiChat from './aiChatSlice';
import emailInbox from './emailInboxSlice';
import userRecommendations from './userRecommendationSlice';
import userSettings from './userSettingsSlice';
import articles from './articlesSlice';
import availabilityRules from './availabilityRulesSlice';
import meetingTypes from './meetingTypesSlice';
import meetings from './meetingsSlice';
import scheduling from './schedulingSlice';
import calendarEvents from './calendarEventsSlice';
import clientRecords from './clientRecordsSlice';
import recordTemplates from './recordTemplatesSlice';
import recordEnums from './recordEnumsSlice';
import templateBuilder from './templateBuilderSlice';
import organizationSettings from './organizationSettingsSlice';
import configurations from './configurationsSlice';
import clientServices from './clientServicesSlice';
import referenceCodes from './referenceCodesSlice';
import clientSessions from './clientSessionsSlice';
import booking from './bookingSlice';
import billingRecords from './billingRecordsSlice';
import superbills from './superbillsSlice';
import myTasks from '../main/apps/my-tasks/store/myTasksSlice';
import meters from './meterSlice';
import features from './featureSlice';
import products from './productSlice';
import paymentSettings from './paymentSettingsSlice';
import helpPanel from './helpPanelSlice';

const createReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    fuse,
    i18n,
    user,
    util,
    subscriptions,
    channels,
    channelInvites,
    channelApplications,
    chimeMeeting,
    contacts,
    post,
    connections,
    groups,
    home,
    notifications,
    fileItems,
    helpContent,
    clients,
    clientsAuthorized,
    organizations,
    organizationReferrals,
    programs,
    orgLocations,
    referrals,
    referralInterest,
    report,
    externalMessages,
    dmChannels,
    support,
    subscriptionPlan,
    videoCall,
    marketing,
    warning,
    aiChat,
    emailInbox,
    userRecommendations,
    userSettings,
    articles,
    availabilityRules,
    meetingTypes,
    meetings,
    scheduling,
    calendarEvents,
    clientRecords,
    recordTemplates,
    recordEnums,
    templateBuilder,
    organizationSettings,
    configurations,
    clientServices,
    referenceCodes,
    clientSessions,
    booking,
    billingRecords,
    superbills,
    myTasks,
    meters,
    features,
    products,
    paymentSettings,
    helpPanel,
    ...asyncReducers,
  });

  /*
	Reset the redux store when user logged out
  */
  if (action.type === 'user/userLoggedOut') {
    state = undefined;
  }

  return combinedReducer(state, action);
};

export default createReducer;
